module.exports = __webpack_public_path__ + "static/media/Error.c49cbbaf.svg";